import { getConsent } from './consent';

/**
 * The activation funnel: did a visitor reach the landing page, sign up, create a project, and issue a report.
 * Four events, no more. Every analytics event in the app goes through sendAnalyticsEvent, which sends only when the visitor
 * has accepted analytics (getConsent is 'granted': a browser sending Global Privacy Control counts as declined) and Google
 * Analytics has actually loaded. Nothing about the person is ever sent: no email, name or id, only the step and, for
 * sign-up, the plan that was chosen. "First" project and "first report" are worked out in Google Analytics by counting each
 * visitor once per step in a funnel exploration.
 */
export const FUNNEL_STEPS = ['landing_view', 'signup_complete', 'project_created', 'report_issued'] as const;
export type FunnelStep = (typeof FUNNEL_STEPS)[number];

/** Send one analytics event if, and only if, the visitor has accepted. Returns whether it was sent. */
export function sendAnalyticsEvent(name: string, params: Record<string, string | number> = {}): boolean {
  if (typeof window === 'undefined' || getConsent() !== 'granted' || typeof window.gtag !== 'function') return false;
  window.gtag('event', name, params);
  return true;
}

export function trackFunnel(step: FunnelStep, params: Record<string, string | number> = {}): boolean {
  return sendAnalyticsEvent(step, { funnel: 'activation', ...params });
}
